/**
 * @owner @Appboy/ingestion
 * @fileoverview POST handler for the "/apps/:app_group_id/quick_add_user_profile" endpoint
 */

import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdQuickAddUserProfileCacheKeys } from "./constants";
import type { PostQuickAddUserProfileProps, PostQuickAddUserProfileResult } from "./types";

export const postQuickAddUserProfile = reactQueryMutationAdapter(
  appsAppGroupIdQuickAddUserProfileCacheKeys,
  (props: PostQuickAddUserProfileProps): Promise<PostQuickAddUserProfileResult> => {
    return fetch(
      `/apps/${props.appGroupId}/quick_add_user_profile`,
      "POST",
      {
        ...(props.externalId && { external_id: props.externalId }),
        ...(props.email && { email: props.email }),
        ...(props.phoneNumber && { phone_number: props.phoneNumber }),
        ...(props.firstName && { first_name: props.firstName }),
        ...(props.lastName && { last_name: props.lastName }),
      },
      {},
      {
        // Suppress the global error modal — the QuickAddUserModal handles errors inline via catch
        propagateFetchRequestError: false,
      }
    );
  }
);
